<script type="text/javascript">
	import { get } from "svelte/store";
	import LoadState from "../../Enums/LoadState";
	import LayerListSwitch from "../../UI/LayerList/LayerListSwitch.svelte";
	import ModalWindow from "../../UI/ModalWindow.svelte";
	import "./ImageCollections.scss";
	import ImageCollectionsStore from "./Store";
	
	let loadState = ImageCollectionsStore.meta.loadState;
	let visible = ImageCollectionsStore.meta.visible;

	ImageCollectionsStore.meta.visible.subscribe((visible) => {
		if (visible) {
			ImageCollectionsStore.actions.init();
		}
	});

	let lastUpdated = ImageCollectionsStore.meta.lastUpdated;

	$: {
		$visible;
		$lastUpdated;
	}

	let imageCollections = ImageCollectionsStore.results.imageCollections;

	let rawFilterString = ImageCollectionsStore.filters.filterString;
	let hstyle = "font-weight:bold;margin-top:5px;margin-bottom:5px;";

	$: {
		$lastUpdated;
		$imageCollections = $imageCollections;
	}

	let reload = () => {
		ImageCollectionsStore.actions.reinit();
	};

</script>

<ModalWindow
	title={`Image Collections (Beta)`}
	hasCloseButton={true}
	hasBackground={false}
	resizable={true}
	draggable={true}
	fullscreen={false}
	padding={true}
	position="top-right"
	height="70%"
	bind:open={$visible} >

	{#if $loadState === LoadState.LOADING}
		<p>Loading...</p>
	{:else if $loadState === LoadState.LOADED}

		{#each $imageCollections as collection, index}
			<div style="border-bottom:1px solid #ddd; margin-bottom:10px;padding-bottom:8px;">
				<h3>{collection.name} ({collection.category})</h3>
				{#each collection.images as image, imageIndex}
					<LayerListSwitch
						label={image.name}
						checked={get(image.visible)}
						valid={(image.isExtent() && image.isExtentSet()) || (image.isQuad() && image.isQuadSet())}
						invalidMessage={"Invalid Bounds"}
						on:change={(e) => { image.collection.store.actions.toggle(e, image); }}
						>
						<slot name="label">{#if image.url !== ""}(link){/if}</slot>
					</LayerListSwitch>
					{#if get(image.visible)}
						<div class="image-sub-properties">
							<div class='layer-list-component'>
								<div class="layer-list-item">
									<div class='lli-label'>Opacity</div>
									<div class='lli-switch'>
										<input
											type="range"
											min="0"
											max="100"
											step="1"
											value={get(image.opacity)*100}
											style="margin-top:10px"
											on:input={(e) => {
												let val = parseFloat(e.target.value) * 0.01;
												image.opacity.set(val);
												ImageCollectionsStore.actions.opacityUpdated(image);
											}}>
									</div>
								</div>
							</div>
						</div>
					{/if}
				{/each}
				{#if collection.images.length === 0}
					<div class='msgbox bg-info'><p>No Images in this collection.</p></div>
				{/if}
			</div>
		{/each}

		{#if $imageCollections.length === 0}
			<div class='msgbox bg-info'><p>No Image Collections are available.</p></div>
		{/if}
		<div>
			<button class="btn btn-sml btn-refresh bg-info" style='width:100%;' on:click={reload}>Refresh Data</button>
		</div>
	{/if}

</ModalWindow>

